// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-q_fL","advertDetailServiceList__header":"c-q_fM","advertDetailServiceList__list":"c-q_fN"};